export const articleDetail = {
  id: 1,
  slug: 'mou-dingliu-nanyixing-qianshou-xinren',
  title: '某顶流男星深夜牵手神秘女子，疑似新恋情曝光',
  excerpt: '据知情人士爆料，该男星与神秘女子在某高档餐厅共进晚餐后牵手离开，举止亲密。',
  category: '明星塌房',
  categorySlug: 'mingxing-tafang',
  author: '吃瓜前线记者',
  date: '2026-07-06',
  updateDate: '2026-07-07',
  views: '128.5万',
  image: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20night%20scene%2C%20luxury%20restaurant%20exterior%2C%20paparazzi%20style%20photography%2C%20warm%20amber%20street%20lighting%2C%20mysterious%20romantic%20atmosphere%2C%20cinematic%20golden%20hour%20tones%2C%20upscale%20urban%20setting&width=1600&height=900&seq=article-hero-01&orientation=landscape',
  content: [
    {
      type: 'paragraph',
      text: '6日晚间，有网友在某高档餐厅偶遇了一位当红顶流男星，并拍下了他与一名神秘女子共进晚餐的画面。据目击者描述，两人在餐厅内举止亲密，用餐结束后还手牵手离开，引发外界对该男星新恋情的猜测。',
    },
    {
      type: 'paragraph',
      text: '根据网友提供的照片来看，该男星当晚身穿黑色休闲装，头戴棒球帽和口罩，刻意保持低调。而与其同行的神秘女子则身着白色连衣裙，长发披肩，身材高挑。两人在餐厅内坐在角落位置，用餐过程中多次相视而笑，气氛十分融洽。',
    },
    {
      type: 'image',
      src: 'https://readdy.ai/api/search-image?query=Upscale%20restaurant%20interior%2C%20dim%20warm%20lighting%2C%20couple%20dining%20in%20corner%20booth%2C%20romantic%20atmosphere%2C%20golden%20amber%20tones%2C%20luxury%20dining%20scene%2C%20soft%20candlelight%2C%20intimate%20setting&width=1200&height=800&seq=article-content-01&orientation=landscape',
      caption: '网友拍到的餐厅内部环境',
    },
    {
      type: 'paragraph',
      text: '更引人注目的是，两人在离开餐厅时全程手牵手，该男星还不时回头与女子交谈，笑容满面。两人随后一同乘坐一辆黑色保姆车离开，目的地不明。',
    },
    {
      type: 'heading',
      text: '女方身份引猜测',
    },
    {
      type: 'paragraph',
      text: '消息传出后，网友们迅速展开\u201C人肉搜索\u201D，试图找出该神秘女子的身份。有网友根据女子的身材和发型推测，她可能是某位新晋女演员；也有人认为可能是圈外人士。目前，关于女方身份的猜测已在各大社交平台引发热议，相关话题阅读量突破2亿。',
    },
    {
      type: 'paragraph',
      text: '值得注意的是，该男星此前在公开场合一直宣称自己单身，粉丝们也一直以\u201C哥哥独美\u201D为荣。此次被拍到与异性亲密互动，无疑给粉丝群体带来了不小的冲击。',
    },
    {
      type: 'heading',
      text: '粉丝反应两极分化',
    },
    {
      type: 'paragraph',
      text: '事件曝光后，该男星的粉丝群体出现了明显的两极分化。一部分粉丝表示支持偶像追求幸福：\u201C哥哥也到了该谈恋爱的年纪了，祝福！\u201D另一部分粉丝则表示难以接受：\u201C一直说单身，现在被拍到算什么？这是欺骗！\u201D',
    },
    {
      type: 'paragraph',
      text: '更有部分激进粉丝开始在社交平台上对女方进行人身攻击，甚至发起\u201C抵制女方\u201D的话题。对此，多位娱乐评论人呼吁粉丝理性追星，尊重偶像的私生活。',
    },
    {
      type: 'heading',
      text: '工作室尚未回应',
    },
    {
      type: 'paragraph',
      text: '截至目前，该男星的工作室尚未对此事件做出任何回应。记者多次尝试联系其经纪人，电话均无人接听。有业内人士分析认为，工作室可能正在评估事件影响，预计将在未来24小时内发布官方声明。',
    },
    {
      type: 'paragraph',
      text: '本网将持续关注此事进展，第一时间为您带来最新报道。同时也提醒各位吃瓜群众，理性吃瓜，不信谣不传谣。',
    },
  ],
  relatedVideos: [
    {
      id: 7,
      title: '盘点那些年被拍到的明星恋情实锤',
      views: '456.2万',
      duration: '15:32',
      image: 'https://readdy.ai/api/search-image?query=Celebrity%20couples%20compilation%20montage%2C%20paparazzi%20style%20photography%2C%20warm%20golden%20tones%2C%20romantic%20urban%20night%20scenes%2C%20entertainment%20news%20collage%2C%20cinematic%20amber%20lighting&width=640&height=640&seq=related-video-01&orientation=squarish',
    },
    {
      id: 13,
      title: '顶流男星历任绯闻女友大盘点',
      views: '328.7万',
      duration: '09:45',
      image: 'https://readdy.ai/api/search-image?query=Timeline%20of%20celebrity%20relationships%2C%20collage%20style%2C%20warm%20vintage%20tones%2C%20entertainment%20gossip%20archive%2C%20golden%20amber%20lighting%2C%20nostalgic%20cinematic%20mood&width=640&height=640&seq=related-video-02&orientation=squarish',
    },
    {
      id: 14,
      title: '粉丝如何看待偶像恋爱？街头采访',
      views: '189.3万',
      duration: '07:18',
      image: 'https://readdy.ai/api/search-image?query=Street%20interview%20scene%2C%20diverse%20people%20speaking%2C%20warm%20daylight%2C%20urban%20street%20background%2C%20documentary%20style%2C%20golden%20hour%20lighting%2C%20natural%20candid%20expressions&width=640&height=640&seq=related-video-03&orientation=squarish',
    },
    {
      id: 15,
      title: '明星恋情曝光后的公关套路解析',
      views: '267.4万',
      duration: '11:20',
      image: 'https://readdy.ai/api/search-image?query=PR%20crisis%20meeting%20scene%2C%20corporate%20office%20setting%2C%20warm%20professional%20lighting%2C%20strategic%20discussion%20atmosphere%2C%20golden%20amber%20tones%2C%20media%20relations%20theme&width=640&height=640&seq=related-video-04&orientation=squarish',
    },
  ],
};

export const allArticles = [
  articleDetail,
  {
    id: 2,
    slug: 'zhiming-wanghong-zhibo-fanche-xianchang',
    title: '知名网红直播翻车现场，口误暴露真实身份引热议',
    excerpt: '该网红在直播中无意间说漏嘴，暴露了自己包装人设背后的真实身份，引发粉丝大规模脱粉。',
    category: '网红黑料',
    categorySlug: 'wanghong-heiliao',
    author: '吃瓜侦探社',
    date: '2026-07-06',
    updateDate: '2026-07-06',
    views: '95.2万',
    image: 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20interior%2C%20dramatic%20moment%20of%20shock%2C%20warm%20ring%20light%20glow%2C%20social%20media%20scandal%20atmosphere%2C%20golden%20amber%20tones%2C%20influencer%20crisis%20theme&width=1600&height=900&seq=article-hero-02&orientation=landscape',
    content: [
      {
        type: 'paragraph',
        text: '近日，一位拥有数百万粉丝的知名网红在直播中意外翻车，因一时口误暴露了自己精心包装的人设背后的真实身份，引发全网热议。',
      },
      {
        type: 'paragraph',
        text: '据悉，该网红一直以\u201C白富美\u201D人设示人，声称自己是某知名企业的高管，日常展示奢华生活方式。然而在最近一次直播中，当被问及工作细节时，她无意中说出了一些与人设严重不符的信息，被细心的网友当场抓包。',
      },
      {
        type: 'heading',
        text: '人设崩塌始末',
      },
      {
        type: 'paragraph',
        text: '事件发生后，网友们迅速展开调查，发现该网红的真实身份与她宣称的相差甚远。所谓的\u201C知名企业高管\u201D实际上只是一名普通职员，展示的豪宅和名车也多是租借或借位拍摄。大量粉丝表示受到欺骗，纷纷脱粉。',
      },
    ],
    relatedVideos: [],
  },
  {
    id: 3,
    slug: 'mou-nvxing-bei-baochu-shuiwuwen',
    title: '某女星被曝税务问题，工作室紧急发声明回应',
    excerpt: '网友爆料某一线女星存在严重税务问题，工作室连夜发布律师函否认，但网友扒出更多证据。',
    category: '明星塌房',
    categorySlug: 'mingxing-tafang',
    author: '吃瓜前线记者',
    date: '2026-07-05',
    updateDate: '2026-07-06',
    views: '210.8万',
    image: 'https://readdy.ai/api/search-image?query=Legal%20office%20scene%2C%20dramatic%20lighting%2C%20documents%20and%20lawyer%20letter%2C%20celebrity%20tax%20scandal%20theme%2C%20warm%20amber%20tones%2C%20tense%20corporate%20atmosphere&width=1600&height=900&seq=article-hero-03&orientation=landscape',
    content: [
      {
        type: 'paragraph',
        text: '日前，有网友在社交平台爆料称某一线女星存在严重的税务问题，涉及金额巨大。该爆料迅速登上热搜，引发广泛关注。',
      },
      {
        type: 'heading',
        text: '工作室紧急回应',
      },
      {
        type: 'paragraph',
        text: '面对舆论压力，该女星工作室连夜发布声明，称相关爆料\u201C纯属造谣\u201D，并表示已委托律师取证，将追究造谣者的法律责任。然而这一回应并未平息舆论，反而有更多网友扒出疑似证据。',
      },
    ],
    relatedVideos: [],
  },
];